import cn from 'classnames';
import React, { FC, PropsWithChildren, memo } from 'react';

import useStyles from './styles.module';

interface Props extends PropsWithChildren {
  className?: string;
}

const Container: FC<Props> = ({ children, className = '' }) => {
  const { classes } = useStyles();

  return <div className={cn(classes.container, className)}>{children}</div>;
};

export default memo(Container);
